export default function initAccordion() {
  const accordions = Array.from(document.querySelectorAll('.accordion'));
  if (!accordions.length) return;

  const isTruthy = (val) => {
    if (val == null) return false;
    const s = String(val).toLowerCase().trim();
    return s === 'true' || s === '1' || s === 'yes' || s === 'on';
  };

  accordions.forEach((root) => {
    const accordionItems = Array.from(root.querySelectorAll('.accordion__left-list-item'));
    if (!accordionItems.length) return;

    const hoverEnabled = isTruthy(root.dataset.accordionHover);
    const leftCol = root.querySelector('.accordion__left');
    const rightCol = root.querySelector('.accordion__right');
    const rightImage = root.querySelector('.accordion__right-image');
    const defaultImage = rightImage ? rightImage.getAttribute('src') : '';

    const setImage = (url) => {
      if (!rightImage) return;
      rightImage.src = url || defaultImage;
    };

    // Keep left and right columns equal height.
    let heightRaf = 0;
    const syncColumnHeights = () => {
      heightRaf = 0;
      if (!leftCol || !rightCol) return;
      // Use the left column as the source-of-truth height.
      const h = leftCol.offsetHeight || 0;
      if (h > 0) rightCol.style.height = `${h}px`;
    };

    const scheduleSync = () => {
      if (heightRaf) return;
      heightRaf = window.requestAnimationFrame(syncColumnHeights);
    };

    // Observe layout changes (accordion open/close, responsive reflow, font load, etc.)
    if (typeof ResizeObserver !== 'undefined' && leftCol) {
      const ro = new ResizeObserver(scheduleSync);
      ro.observe(leftCol);
    } else {
      window.addEventListener('resize', scheduleSync);
    }

    const setFaded = (activeItem) => {
      accordionItems.forEach((otherItem) => {
        if (!activeItem || otherItem === activeItem) {
          otherItem.classList.remove('faded');
          return;
        }
        otherItem.classList.add('faded');
      });
    };

    const openItem = (item) => {
      const content = item.querySelector('.accordion__left-list-item-content');
      const title = item.querySelector('.accordion__left-list-item-title');

      accordionItems.forEach((otherItem) => {
        if (otherItem === item) return;
        const otherContent = otherItem.querySelector('.accordion__left-list-item-content');
        const otherTitle = otherItem.querySelector('.accordion__left-list-item-title');
        if (otherContent) otherContent.classList.remove('active');
        if (otherTitle) otherTitle.classList.remove('active');
      });
      setFaded(item);

      if (content) content.classList.add('active');
      if (title) title.classList.add('active');
      setImage(item.dataset.image);
      scheduleSync();
    };

    const closeItem = (item) => {
      const content = item.querySelector('.accordion__left-list-item-content');
      const title = item.querySelector('.accordion__left-list-item-title');
      if (content) content.classList.remove('active');
      if (title) title.classList.remove('active');
      setFaded(null);
      setImage(null);
      scheduleSync();
    };

    accordionItems.forEach((item) => {
      const titleLink = item.querySelector('.accordion__left-list-item-title');

      // Hover always swaps the right-hand image (and can optionally open)
      item.addEventListener('mouseenter', () => {
        setFaded(item);
        setImage(item.dataset.image);
        if (hoverEnabled) openItem(item);
        scheduleSync();
      });

      item.addEventListener('mouseleave', () => {
        setFaded(null);
        setImage(null);
        if (hoverEnabled) closeItem(item);
        scheduleSync();
      });

      // Click-to-expand (first click expands, second click follows link)
      if (titleLink) {
        titleLink.addEventListener('click', (e) => {
          if (hoverEnabled) return; // hover mode: click should behave like a normal link
          const isActive = titleLink.classList.contains('active');
          if (!isActive) {
            e.preventDefault();
            openItem(item);
          }
        });
      }
    });

    // Initial sync (after images/fonts/layout settle).
    scheduleSync();
    window.addEventListener('load', scheduleSync, { once: true });
  });
}
